import { defineComponent as _defineComponent } from 'vue'
import DashboardNavbar from '@/components/DashboardNavbar.vue';
  import TheFooterVue from '@/components/TheFooter.vue';
  import { UseUserActions } from '@/composables/useUserActions';
  import { Suspense } from 'vue';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardLayout',
  setup(__props, { expose: __expose }) {
  __expose();

  const { getMe } = UseUserActions();
  const checkMe = async () => {
    await getMe();
  };
  checkMe();

const __returned__ = { getMe, checkMe, DashboardNavbar, TheFooterVue, get UseUserActions() { return UseUserActions }, Suspense }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})